import React from 'react';
import { GoChevronDown } from 'react-icons/go';
import VideoPlayer from '../../../../../../components/VideoPlayer';
import Img from '../../../../../../components/Img/Img';
import WidgetPreviewProductItem from '../WidgetPreviewProductItem';
import { PRODUCT_ATTACHMENT_TYPE } from '../../../../../../constants/service/app/productConstants';
import './WidgetPreviewProductDetailWrap.scss';

const WidgetPreviewProductDetailWrap = (props) => {
  const { detailTopImg, selectedWidgetItemList } = props;

  return (
    <div className="widget-preview-product-detail-wrap">
      {detailTopImg && detailTopImg.length
        ? detailTopImg.map((item, i) =>
            item.type === PRODUCT_ATTACHMENT_TYPE.VIDEO ? (
              <VideoPlayer key={i} width={'100%'} height={'100%'} controls={true} url={item.url} />
            ) : (
              <Img key={i} clickAble={false} src={item && item.url ? item.url : ''} />
            ),
          )
        : null}

      <div className="filter">
        트랜드순
        <GoChevronDown />
      </div>

      <div className="widget-detail-item-list">
        {selectedWidgetItemList.map((productItem, index) => (
          <WidgetPreviewProductItem key={index} productItem={productItem} />
        ))}
      </div>
    </div>
  );
};

export default WidgetPreviewProductDetailWrap;
